import SEO from "components/seo";
import Layout from "components/layout";
import TechnicalTranslation from "components/reusableComponents/TechnicalTranslation";
import React from "react";

function index() {
  const title = "Professional technical translation services";
  const description =
    "Our technical translation services are guaranteed to have the technical expertise required to translate complex source content from various scientific and technical fields.";
  const keywords =
    "technical translation, professional technical translation, technical translation quote English to technical translation";
  const slug = "/technical-translation.php";
  return (
    <Layout>
      <SEO
        title={title}
        description={description}
        keywords={keywords}
        slug={slug}
      />
      <TechnicalTranslation />
    </Layout>
  );
}

export default index;
